export const NEXT_PUBLIC_REACT_APP_DOMAIN =
  process.env.NEXT_PUBLIC_REACT_APP_DOMAIN;
export const NEXT_PUBLIC_LOCAL_ENV = process.env.NEXT_PUBLIC_LOCAL_ENV;
export const NEXT_PUBLIC_TOKEN = process.env.NEXT_PUBLIC_TOKEN;

export type TCE_ENV = "offline" | "online";

export const YOO_FINDS_DOMAIN_API = {
  // 测试
  offline: "https://api.test.yoofinds.com/",
  // 生产
  online: "https://api.yoofinds.com/",
}[NEXT_PUBLIC_REACT_APP_DOMAIN as TCE_ENV];

// 埋点域名
export const TRACK_DOMAIN_API = {
  // 测试
  offline: "https://tracking.test.yoofinds.com/",
  // 生产
  online: "https://tracking.yoofinds.com/",
}[NEXT_PUBLIC_REACT_APP_DOMAIN as TCE_ENV];

// 前端域名
export const YOO_FINDS_DOMAIN = {
  // 测试
  offline: "https://mtest.yoofinds.com",
  // 生产
  online: "https://m.yoofinds.com",
}[NEXT_PUBLIC_REACT_APP_DOMAIN as TCE_ENV];

// FM 域名
export const FAST_MOSS_DOMAIN = {
  // 测试
  offline: "https://mtest.fastmoss.com",
  // 生产
  online: "https://m.fastmoss.com",
}[NEXT_PUBLIC_REACT_APP_DOMAIN as TCE_ENV];

export const YOO_FINDS_CDN = "https://cdn.yoofinds.com";

export const PRIVACY_URL = "https://www.yoofinds.com/doc/privacy.html";

export const TERMS_URL = "https://www.yoofinds.com/doc/terms.html";

export const PAYPAL_PRIVACY_URL =
  "https://www.paypal.com/us/legalhub/paypal/privacy-full#paypal_privacy_statement";

export const APP_YOO_FINDS = "yoofinds";

export const YOO_FINDS_CLIENT_INFO = "client_info";

export const YOO_FINDS_TOKEN = "token";

export const YOO_FINDS_USER_INFO = "user_info";

export const YOO_FINDS_UID = "uid";

export const YOO_FINDS_UID_KEY = "Yoofinds_uid";

export const APP_SCHEME = "yoofinds";
export const OS_IOS = "ios";

export const YOO_FINDS_AD_TASKS_TIP_SHOW = "yf_ad_tasks_tip_show";

export const APPLE_STORE_URL =
  "https://apps.apple.com/us/app/yolobuyer/id6450421269";
export const GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.yolobuyer.yolobuyer";

export const APPLE_STORE_TRACK_URL =
  "https://track.tenjin.com/v0/click/esTOHdZSeSDEQ9fuxndobl";
export const ANDROID_STORE_TRACK_URL =
  "https://track.tenjin.com/v0/click/eqlApap6iMxYBgoqLjsaw8";

export const CLIENT_TYPE_WEB_H5 = 2;

export const SAMPLE_AUTHORIZE_TT_LINK = `https://www.tiktok.com/alliance/ecom/fe/h5/default/fe_teu_h5_alliance/partner-notifications/notification-center?hide_nav_bar=1&tea_init_time=${Date.now()}&enter_from=ec_center_page&source_page_type=show_window&disable_tea_intercept=1`;
